import { NgModule, Optional, SkipSelf } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { OrderEffects } from './order.effects';
import { IOrderFeature } from './order.feature.state';
import { OrderReducer } from './order.reducer';
import { nameof } from '@symphony-solo/shared/utils/src';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<IOrderFeature>('OrderFeature'), OrderReducer),
    EffectsModule.forFeature([OrderEffects]),
  ],
})
export class OrderStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: OrderStateModule
  ) {
    if (parentModule) {
      throw new Error('OrderStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
